module.exports = __webpack_public_path__ + "static/media/mail-icon.0934a6fa.svg";